// Add your JS customizations here
"use strict";

window.jQuery.migrateMute = true;
//-----------------auto year change------------
document.addEventListener("DOMContentLoaded", function() {
    const today = new Date();
    const year = today.getFullYear();


    if(document.getElementsByClassName("update-year").length> 0){
        document.getElementsByClassName("update-year")[0].innerHTML = year;
    }
    //-----------------button load more ------------

    const productList = document.getElementById("merchant-product-list");
    if(productList){
        const loadMoreButton = document.getElementById("load-more-button");
        const products = Array.from(productList.getElementsByTagName("li"));
        const productsToShow = 15; // Number of products to initially show
        let visibleProducts = productsToShow;

        // Create No Results Message Element
        const noResultsMessage = document.createElement("p");
        noResultsMessage.id = "no-results-message";
        noResultsMessage.textContent = "No Results Found";
        noResultsMessage.style.display = "none";
        productList.parentNode.insertBefore(noResultsMessage, productList.nextSibling);


        // Function to show additional products
        function showMoreProducts(isClicked) {
            if(isClicked){
                visibleProducts += productsToShow;
            }

            products.forEach((product, index) => {
                if (index < visibleProducts) {
                    product.style.display = "block";
                } else {
                    product.style.display = "none";
                }
            });

            if (visibleProducts >= products.length) {
                loadMoreButton.style.display = "none"; // Hide the button when all products are shown
            }
        }

        loadMoreButton.addEventListener("click", function () {
            // Pass the number of products to load as a parameter (e.g., 15)
            showMoreProducts(true);
        });

        // Initialize the display of products
        showMoreProducts(false);

        //----------------- The list of products is filtered in real-time ------------

        const searchInput = document.getElementById("search");

        // Function to handle search input
        function handleSearch() {
            const searchTerm = searchInput.value.toLowerCase();
            let matchFound = false;

            products.forEach((product, index) => {
                const productText = product.textContent.toLowerCase();
                if (searchTerm.length && productText.includes(searchTerm)) {
                    product.style.display = "flex";
                    matchFound = true;
                } else if (!searchTerm.length && index < visibleProducts) {
                    product.style.display = "block";
                } else {
                    product.style.display = "none";
                }
            });

            // Toggle No Results Message
            noResultsMessage.style.display = matchFound || !searchTerm.length ? "none" : "block";

        }

        const searchButton = document.getElementById("search-button");
        // Function to toggle the visibility of the "Load More" button
        function toggleLoadMoreButtonVisibility() {
            if (searchInput.value.trim() === "") {
                loadMoreButton.style.display = "inline-flex";
            } else {
                loadMoreButton.style.display = "none";
            }
        }

        // Event listener for input changes
        searchInput.addEventListener("input", toggleLoadMoreButtonVisibility);

        // Event listener for the search button
        searchButton.addEventListener("click", function () {

            // After displaying search results, hide the "Load More" button
            loadMoreButton.style.display = "none";
        });

        // Initial button visibility
        toggleLoadMoreButtonVisibility();

        // Event listener for search input
        searchInput.addEventListener("input", handleSearch);

    }

    if (document.querySelectorAll(".edd-payment-icons").length > 0) {
        // Get the first div element with the class "edd-payment-icons"
        var div = document.querySelector(".edd-payment-icons");

        // Create an h2 element
        var heading = document.createElement("h2");
        // Create a text node for the h2
        var textNode = document.createTextNode("Payment Method");
        // Append the text node to the h2
        heading.appendChild(textNode);

        // Insert the h2 before the first child of the div
        div.insertBefore(heading, div.firstChild);
    }

});

//-----------------blog details page progress bar added------------

document.addEventListener("DOMContentLoaded", () => {
    const progressBar = document.getElementById("rex-blog-details-progress-bar");
    const startElement = document.querySelector(".rextheme-blog-details-header-content");
    const endElement = document.querySelector(".rex-single-blog-post-content");

    if (progressBar && startElement && endElement) {
        const calculateProgress = () => {
            // Get the viewport height
            const viewportHeight = window.innerHeight;

            // Get the starting and ending positions relative to the viewport
            const startRect = startElement.getBoundingClientRect();
            const endRect = endElement.getBoundingClientRect();

            // Calculate the total scrollable distance
            const startOffset = window.pageYOffset + startRect.top;
            const endOffset = window.pageYOffset + endRect.bottom;
            const totalScrollableDistance = endOffset - startOffset - viewportHeight;

            // Calculate how far we've scrolled from the start
            const currentScroll = window.pageYOffset - startOffset;

            // Calculate the percentage
            let percentage = (currentScroll / totalScrollableDistance) * 100;

            // Clamp the percentage between 0 and 100
            percentage = Math.min(100, Math.max(0, percentage));

            return percentage;
        };

        // Update progress bar
        const updateProgressBar = () => {
            const progress = calculateProgress();

            // Only show progress bar when we've reached the start element and haven't reached the end
            if (window.pageYOffset >= startElement.offsetTop && progress < 100) {
                progressBar.style.display = "block";
                progressBar.style.width = `${progress}%`;
            } else {
                progressBar.style.display = "none";
                progressBar.style.width = "0%";
            }
        };

        // Add scroll event listener
        window.addEventListener("scroll", updateProgressBar);

        // Add resize event listener to handle window resizing
        window.addEventListener("resize", updateProgressBar);

        // Initial update
        updateProgressBar();
    }
});

/**
 * Live Search Implementation
 *
 * This module handles real-time search functionality with the following features:
 * - Debounced API calls to prevent excessive requests
 * - Accessibility support with ARIA attributes
 * - Error handling for failed API requests
 * - Loading states and empty states
 * - Minimum character threshold for search
 * - Result caching for improved performance
 * - Cache expiry
 */

document.addEventListener("DOMContentLoaded", initializeSearch);
const CONSTANTS = {
  MIN_CHARS: 2,
  DEBOUNCE_DELAY: 300,
  SELECTORS: {
    SEARCH_INPUT: ".rex-blog-form-control",
    RESULTS_DROPDOWN: "#rex-blog-search-results"
  },
  CACHE_EXPIRY_TIME: 60 * 60 * 1000 // 1 hour in milliseconds
};

// Cache for storing search results
const searchCache = new Map();

function initializeSearch() {
  const searchInput = document.querySelector(CONSTANTS.SELECTORS.SEARCH_INPUT);
  const resultsDropdown = document.querySelector(CONSTANTS.SELECTORS.RESULTS_DROPDOWN);

  if (!searchInput || !resultsDropdown) {
    console.error("Required search elements not found");
    return;
  }

  // Setup accessibility attributes
  setupAccessibility(searchInput, resultsDropdown);

  let debounceTimer;

  // Add click outside listener to close results
  document.addEventListener('click', (e) => {
    if (!searchInput.contains(e.target) && !resultsDropdown.contains(e.target)) {
      clearResults(resultsDropdown);
      searchInput.setAttribute("aria-expanded", "false");
    }
  });

  // Add input event listener
  searchInput.addEventListener("input", () => handleSearchInput(
    searchInput,
    resultsDropdown,
    debounceTimer
  ));

  // Add keyboard navigation
  searchInput.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      clearResults(resultsDropdown);
      searchInput.setAttribute("aria-expanded", "false");
    }
  });
}

/**
 * Sets up ARIA attributes for accessibility
 * @param {HTMLElement} input - Search input element
 * @param {HTMLElement} results - Results container element
 */
function setupAccessibility(input, results) {
  input.setAttribute("role", "searchbox");
  input.setAttribute("aria-expanded", "false");
  input.setAttribute("aria-controls", results.id);
  input.setAttribute("aria-label", "Search");
  results.setAttribute("role", "listbox");
}

/**
 * Handles input events on the search field
 * @param {HTMLElement} input - Search input element
 * @param {HTMLElement} results - Results container element
 * @param {number} timer - Debounce timer reference
 */
function handleSearchInput(input, results, timer) {
  const query = input.value.trim();

  // Clear results immediately if query is empty
  if (!query) {
    clearResults(results);
    input.setAttribute("aria-expanded", "false");
    return;
  }

  if (query.length >= CONSTANTS.MIN_CHARS) {
    showLoadingState(results);
    document.getElementById("rex-blog-search-results").style.display = "block";
    input.setAttribute("aria-expanded", "true");

    clearTimeout(timer);
    timer = setTimeout(() => {
      performSearch(query, results);
    }, CONSTANTS.DEBOUNCE_DELAY);
  } else {
    showNoResults(results, "Please enter at least 2 characters.");
    input.setAttribute("aria-expanded", "false");
  }
}

/**
 * Performs the search API call and handles the response
 * @param {string} query - Search query
 * @param {HTMLElement} results - Results container element
 */
async function performSearch(query, results) {
  // Check cache first
  if (searchCache.has(query)) {
    const cachedResult = searchCache.get(query);

    // Check if the cached result is still valid
    if (Date.now() - cachedResult.timestamp < CONSTANTS.CACHE_EXPIRY_TIME) {
      updateResults(cachedResult.data, results);
      return;
    } else {
      // Remove expired cache entry
      searchCache.delete(query);
    }
  }

  try {
    const response = await fetch(
      `${rextheme_ajax.url}?action=rex_theme_live_search&term=${encodeURIComponent(query)}`
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    // Cache the results with timestamp
    searchCache.set(query, { data, timestamp: Date.now() });
    updateResults(data, results);
  } catch (error) {
    console.error("Search failed:", error);
    showError(results);
  }
}

/**
 * Updates the results container with search results
 * @param {Array} data - Search results data
 * @param {HTMLElement} results - Results container element
 */
function updateResults(data, results) {
  // Set min-height during loading to prevent jumping
  const currentHeight = results.offsetHeight;
  results.style.minHeight = `${currentHeight}px`;
  results.style.marginTop = "12px";

  results.innerHTML = "";

  if (data.length > 0) {
    const fragment = document.createDocumentFragment();

    data.forEach((item, index) => {
      const listItem = document.createElement("li");
      const link = document.createElement("a");

      link.href = item.url;
      link.textContent = item.title;
      link.setAttribute("role", "option");
      link.setAttribute("tabindex", "0");
      link.setAttribute("aria-selected", "false");

      // Add hover effect handler
      link.addEventListener('mouseenter', () => {
        results.querySelectorAll('a').forEach(a => a.setAttribute('aria-selected', 'false'));
        link.setAttribute('aria-selected', 'true');
      });

      listItem.appendChild(link);
      fragment.appendChild(listItem);
    });

    results.appendChild(fragment);
  } else {
    showNoResults(results);
  }

  // Reset min-height after results are loaded
  setTimeout(() => {
    results.style.minHeight = '';

  }, 150);
}

/**
 * Display loading state
 * @param {HTMLElement} results - Results container element
 */
function showLoadingState(results) {
  const currentHeight = results.offsetHeight;
  results.style.minHeight = `${currentHeight}px`;
  results.style.marginTop = "12px";
  results.innerHTML = '<li class="loading" aria-label="Loading results"><div class="rex-search-loader"><div class="rex-search-simple-circle"></div></div></li>';
}

/**
 * Display no results message
 * @param {HTMLElement} results - Results container element
 */
function showNoResults(results, message = "No Results Found") {
  results.innerHTML = `<li class="no-results" role="status">${message}</li>`;
}

/**
 * Display error message
 * @param {HTMLElement} results - Results container element
 */
function showError(results) {
  results.innerHTML = `
    <li class="error" role="alert">
      An error occurred. Please try again. <button onclick="retrySearch()">Retry</button>
    </li>
  `;
}

/**
 * Retry the search
 */
function retrySearch() {
  const searchInput = document.querySelector(CONSTANTS.SELECTORS.SEARCH_INPUT);
  handleSearchInput(searchInput, document.querySelector(CONSTANTS.SELECTORS.RESULTS_DROPDOWN), null);
}

/**
 * Clear all results
 * @param {HTMLElement} results - Results container element
 */
function clearResults(results) {
  results.style.minHeight = '';
  results.style.marginTop = '';
  document.getElementById("rex-blog-search-results").style.display = "none";
  results.innerHTML = "";
}

/**
 * Clear the search cache
 * Call this when you want to force fresh results
 */
function clearSearchCache() {
  searchCache.clear();
}


(function ($) {
    "use strict";
    var wWidth = $(window).width();
    var main_wind = $(window);

    jQuery(document).ready(function ($) {

        // Select the fifth breadcrumb item's link title
        const breadTitle = $(".betterdocs-breadcrumb-item:eq(4) .bread-link").attr("title");

        // Check if breadTitle exists and is not empty
        if (breadTitle) {
            // Construct the HTML to prepend
            const htmlToPrepend = `<h2 class="live-search-title">${breadTitle}</h2>`;

            // Prepend the HTML to the live search section
            $(".betterdocs-single-wrapper .betterdocs-live-search").prepend(htmlToPrepend);
        }

        // Select the fifth breadcrumb item's link title
        const breadCategoryTitle = $(".betterdocs-breadcrumb-item:eq(4) .bread-link").attr("title");

        // Check if breadTitle exists and is not empty
        if (breadCategoryTitle) {
            // Construct the HTML to prepend
            const htmlToPrepend = `<h2 class="live-search-title">${breadCategoryTitle}</h2>`;

            // Prepend the HTML to the live search section
            $(".betterdocs-taxonomy-wrapper .betterdocs-search-heading").prepend(htmlToPrepend);
        }

        // Cache the toggle elements
        let nestedCategoriesToggle = $(".betterdocs-taxonomy-wrapper  .betterdocs-nested-category-title");
        nestedCategoriesToggle.addClass("disabled");
        function nestedCategoryToggler() {
            // Remove elements with the `.toggle-arrow` class
            $(".betterdocs-taxonomy-wrapper .toggle-arrow").remove();

            // Show all nested category lists by default
            $(".betterdocs-taxonomy-wrapper .betterdocs-nested-category-list").show();

            // Remove previously bound event handlers to prevent duplicates
            nestedCategoriesToggle.off("click");
        }

        // Initialize the toggler
        nestedCategoryToggler();


        const feedbackContent = $(".feedback-form-link").contents()
            .filter(function () {
                return this.nodeType === 3; // Node type 3 refers to text nodes
            }).text().trim();

            // Split the content into two parts
            const parts = feedbackContent.split("? ");

            // Update the content dynamically with styled spans
            $(".feedback-form-link").html(function (_, oldHtml) {
                return oldHtml.replace(
                    feedbackContent,
                    `<span>${parts[0]}?</span><span class="help-text"> ${parts[1] }</span>`
                );
            });

        /*-------- toggle Button cookies added -----------*/
        var lightMode =  Cookies.get('light');
        if(lightMode == 'light-mode'){

            if($(".wpfm-switch-area").length > 0){
                 $('body').toggleClass('light-mode');
            }
        }

        $('.wpfm-switch-area').on('click', function() {
            $('body').toggleClass('light-mode');

            var mode = '';
            if(lightMode == 'light-mode'){
                mode = '';
            }else {
                mode = 'light-mode';
            }
            Cookies.set('light', mode);

        });

        /*--------navbar dropdown toggle-----------*/
        if($(window).width() < 992){
            $('.rex-navbar .menu-item-has-children > .dropdown-arrow').on('click', function(e){
                e.stopPropagation();
                $(this).parents('li.menu-item').toggleClass('show-dropdown');
                $(this).parents('li.menu-item').siblings().removeClass('show-dropdown');

                $(this).siblings('ul.dropdown-menu').slideToggle(200);
                $(this).parent().siblings('li').find('ul.dropdown-menu').slideUp(200);
            });
            $('.rex-navbar .menu-item-has-children ul.dropdown-menu').on('click', function(e){
                e.stopPropagation();
            });
            $('body').on('click', function(){
                $('.rex-navbar .menu-item-has-children ul.dropdown-menu').slideUp(200);
            });
        }

        //--------edd checkout page billing text---------
        $("#edd_cc_fields > legend").text('Billing Details');

        //--------append search icon into blog sidebar first widget---------
        $(".rex-sidebar .single-widget:nth-child(2):not(.widget_search) .widget-title").append('<span class="search-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"/></svg></span>');

        $(".rex-sidebar .widget.single-widget.widget_categories").prepend('<div class="search-area-modal-form">\n' +
          '\t\t\t<form action="'+ window.rextheme_ajax.home_url +'">\n' +
          '\t\t\t<span class="search-close">\n' +
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M7.22221 13.4444C10.6586 13.4444 13.4444 10.6586 13.4444 7.22221C13.4444 3.78578 10.6586 1 7.22221 1C3.78578 1 1 3.78578 1 7.22221C1 10.6586 3.78578 13.4444 7.22221 13.4444Z" stroke="#B4B8C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          '<path d="M15 15L11.6167 11.6166" stroke="#B4B8C1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
          '</svg>\n</span>\n' +
          '\t\t\t\t<input type="search" name="s" placeholder="Insert your keyword here and press Enter">\n' +
          '\t\t\t\t<button type="submit" class="submit"></button><button class="close-search-button"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
          '<path d="M11 1L1 11" stroke="#080735" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
          '<path d="M1 1L11 11" stroke="#080735" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>\n' +
          '</svg></button>\n' +
          '\t\t\t</form>\n' +
          '\t\t</div>');

        /*--------search bar showing-----------*/
        $(".search-icon").on("click", function () {
            $(".search-area-modal-form").show();
            $(".search-overlay").addClass("show-overlay");
            $(this).hide()
        });

        /*--------search bar showing-----------*/
        $(".close-search-button").on("click", function (e) {
            e.preventDefault()
            $(".search-area-modal-form").hide();
            $(".search-icon").show();
        });
        $(".search-area-modal > .search-close").on("click", function () {
            $(".search-area-modal").removeClass("show-search");
            $(".search-overlay").removeClass("show-overlay");
        });

        //-------testimonial active class----------
        $(".rex-testimonial .single-testimonial:nth-child(5)").addClass("active");

        $(".rex-testimonial .single-testimonial .img-area").hover(function () {
            $(this).parent(".single-testimonial").addClass("active");
            $(this).parent(".single-testimonial").siblings().removeClass("active");
        }, function () {
            $(this).parent(".single-testimonial").removeClass("active");
            $(".rex-testimonial .single-testimonial:nth-child(5)").addClass("active");
        });

        //----venobox----
        $(".venobox").venobox();

        //------pricing table plan switcher-------
        $('#price-switcher,#rex-billing-switcher').on('change', function(){
            if($(this).is(":checked")) {
                if( $('.rex-badge-best-value').length > 0 ){
                    $('.rex-badge-best-value').show();
                }

                if( $('.rex-badge-best-annual-value').length > 0 ){
                    $('.rex-badge-best-annual-value').hide();
                }

                $('.annual-plan').css('display', 'none');

                $('.lifetime-plan').css('display', 'flex');
                $(this).siblings('span.annual').removeClass('active');
                $(this).siblings('span.lifetime').addClass('active');
            } else {

                if( $('.rex-badge-best-value').length > 0 ){
                    $('.rex-badge-best-value').hide();
                }

                if( $('.rex-badge-best-annual-value').length > 0 ){
                    $('.rex-badge-best-annual-value').show();
                }

                $('.annual-plan').css('display', 'flex');
                $('.lifetime-plan').css('display', 'none');
                $(this).siblings('span.annual').addClass('active');
                $(this).siblings('span.lifetime').removeClass('active');
            }
        });

        //------rex dynamic pricing table plan switcher-------
        $('#dynamic-price-switcher').on('change', function(){
          if($(this).is(":checked")) {
            $('section.rex-bundle-pricing-landing .annual-plan').css('display', 'none');
            $('section.rex-bundle-pricing-landing .lifetime-plan').css('display', 'grid');
            $('section.rex-bundle-pricing-landing span.annual').removeClass('active');
            $('section.rex-bundle-pricing-landing span.lifetime').addClass('active');
          } else {
            $('section.rex-bundle-pricing-landing .annual-plan').css('display', 'grid');
            $('section.rex-bundle-pricing-landing .lifetime-plan').css('display', 'none');
            $('section.rex-bundle-pricing-landing span.annual').addClass('active');
            $('section.rex-bundle-pricing-landing span.lifetime').removeClass('active');
          }
        });
        // $('#dynamic-price-switcher').prop('checked', true).trigger('change');

       //------dynamic-sticky-price-switcher -------

        $('#dynamic-sticky-price-switcher').change(function(){
          if($(this).is(":checked")) {
            $('#rex-price-sticky-area .annual-plan').css('display', 'none');
            $('#rex-price-sticky-area .lifetime-plan').css('display', 'flex');
            $('#rex-price-sticky-area span.annual').removeClass('active');
            $('#rex-price-sticky-area span.lifetime').addClass('active');
          } else {
            $('#rex-price-sticky-area .annual-plan').css('display', 'flex');
            $('#rex-price-sticky-area .lifetime-plan').css('display', 'none');
            $('#rex-price-sticky-area span.annual').addClass('active');
            $('#rex-price-sticky-area span.lifetime').removeClass('active');
          }
        });

        // $('#dynamic-sticky-price-switcher').prop('checked', true).trigger('change');


      //------black friday landing page pricing table tab-------
        $('.pricing-tbl-navbar > li:first-child').addClass('active');

        $(document).on("click",".pricing-tbl-navbar  li", function() {
            var dataTarget = $(this).attr('data-target');

            if($(window).width() < 992) {
                $(this).parents('.slick-slide').siblings().find('li').removeClass('active');
                $(this).addClass('active');

            } else {
                $(this).addClass('active').siblings().removeClass('active');
            }

            $('.price-tab-content-wrapper .'+dataTarget).siblings('.single-price-tab-content').hide();
            $('.price-tab-content-wrapper .'+dataTarget).show();
        })


        //------dynamic pricing table tab 2024-------
        $('.rex-faq-tabs > li').on('click', function(){
            var dataTarget = $(this).attr('data-target');
            $(this).addClass('active').siblings().removeClass('active');

            $('.rex-faq__wrapper .'+dataTarget).siblings('.rex-faq__content').hide();
            $('.rex-faq__wrapper .'+dataTarget).show();
        });
        $('.rex-faq-tabs > li:first-child').addClass('active');
        $('.rex-faq-tabs > li:first-child').trigger('click');


        //------black friday landing page pricing table plan switcher-------
        $('.price-switcher').on('change', function(){
            if($(this).is(":checked")) {
                $(this).parents('.single-price-tab-content').find('.annual-plan').css('display', 'none');
                $(this).parents('.single-price-tab-content').find('.lifetime-plan').css('display', 'flex');
                $(this).parents('.pricing-switcher').find('span.annual').removeClass('active');
                $(this).parents('.pricing-switcher').find('span.lifetime').addClass('active');
            } else {
                $(this).parents('.single-price-tab-content').find('.annual-plan').css('display', 'flex');
                $(this).parents('.single-price-tab-content').find('.lifetime-plan').css('display', 'none');
                $(this).parents('.pricing-switcher').find('span.annual').addClass('active');
                $(this).parents('.pricing-switcher').find('span.lifetime').removeClass('active');
            }
        });

        //------black friday landing page scroll to pricing table section-------
        $(".bf-hero-area .hero-content .bf-btn, .christmas-hero-area .hero-content .bf-btn,.wpvr-user-story-hero .wpvr-cta-btn-area a.wpvr-cta-btn ").on('click', function(e) {
            e.preventDefault();
            var target = $(this).attr('href');

            $('html, body').animate({
                scrollTop: $(target).offset().top - 120
            }, 1000);
        });

        /*
        * Clone all anchor (<a>) elements within the '.bf-hero__product-discount' container
        * and store the clones in the 'productItems' variable.
        *
        * Next, append the cloned items back to the '.bf-hero__product-discount' container.
        * This operation duplicates the links, effectively doubling the items displayed within this section.
        */


        //-------wpvr-sales-pricing active class add remove on hover-----
        $(".wpvr-sales-pricing .single-plan").hover(function(){
            $(this).addClass("active");
            $(this).siblings(".popular").removeClass("active");
            }, function(){
            $(this).removeClass("active");
            $(".wpvr-sales-pricing .single-plan.popular").addClass("active");
        });

        $(".wpvr-sales-pricing .single-plan .vr-sales-btn").hover(function(){
            $(this).parents('.wpvr-sales-pricing .single-plan').siblings().find('.vr-sales-btn').addClass('bg');
            }, function(){
            $(this).parents('.wpvr-sales-pricing .single-plan').siblings().find('.vr-sales-btn').removeClass('bg');
        });

        //------ rex scroll to nav---------
        let selectors = '.page-template-template-wpvr-pricing .wpvr-cta a.wpvr-cta-btn, a.rex-dy-nav-link, .rex-dynamic-price-view-plan a, .comparison-tbl-col.pro > a, .page-template-template-wpfm-pricing .footer__cta .wpfm-btn, .page-template-template-wpvr-pricing .comparison-tbl-col.pro .wpvr-cta-btn, .regular-promotional-banner-link';

        $(selectors).click(function(event) {
            var id = $(this).attr("href");
            var target = $(id);
            $('html, body').animate({
                scrollTop:target.offset().top
            }, {
                duration: 1500,
                step: function( now, fx ) {
                    var newOffset = target.offset().top;
                    if(fx.end !== newOffset)
                        fx.end = newOffset;
                }
            });
        });

        $(window).on('scroll', function(){
            if ($(window).scrollTop() >= 1250) {
                $('.rex-hero-nav-area').addClass('fixed-header');
            }
            else {
                $('.rex-hero-nav-area').removeClass('fixed-header');
            }
        });


        //------salse coundown timer---------
        if( rextheme_ajax.countdown_date ){
            var offset = (new Date()).getTimezoneOffset();
            $('#sales_countdown').downCount({
                date: ''+rextheme_ajax.countdown_date+'', //month/date/year   HH:MM:SS
                offset: -offset / 60 //+GMT
            });
        }

        //------christmas campaign countdown timer---------
        if( rextheme_ajax.christmas_countdown_date ){
            var offset = (new Date()).getTimezoneOffset();
            $('#christmas_countdown').downCount({
                date: ''+rextheme_ajax.christmas_countdown_date+'', //month/date/year   HH:MM:SS
                offset: -offset / 60 //+GMT
            });
        }

        //------scroll to pricing table---------
        $(' a.purchase, a.wpvr-claim, a.bundle-btn').click(function(event) {
            event.preventDefault();
            var id = $(this).attr("href");
            var target = $(id);
            $('html, body').animate({
                scrollTop:target.offset().top
            }, {
                duration: 1500,
                step: function( now, fx ) {
                    var newOffset = target.offset().top;
                    if(fx.end !== newOffset)
                        fx.end = newOffset;
                }
            });
        });

        //---append icon on doc page li---
        $(".rex-doc-details .doc-nav-list > li.page_item_has_children").append('<i class="fa fa-angle-down"></i>');
        $('.rex-doc-details .doc-nav-list > li.page_item_has_children > i.fa').on('click', function(){
            $(this).toggleClass('active');
            $(this).siblings('.children').slideToggle();
            $(this).parent().siblings('li').children('.children').slideUp();
        });


        jQuery(document).on("click",".hsd_goback",function(t){
            t.preventDefault();
            let e=jQuery(this).attr("href")+"?active_tab=support";
            window.location.href=e

        });


        //-------- wpvr testimonial carousel-------------
        var carouselPrevIcon = '<svg width="19" height="14" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.63735 12C7.75789 12 7.87575 11.9226 7.94453 11.7816C8.05089 11.5635 7.99972 11.2758 7.83024 11.139L1.55481 6.07135C1.38529 5.93449 1.16174 6.00045 1.05547 6.21842C0.949112 6.4365 1.00028 6.72416 1.16976 6.86102L7.44519 11.9286C7.505 11.9769 7.57161 12 7.63735 12Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/><path d="M1.36265 7C1.42844 7 1.495 6.97693 1.55486 6.92863L7.83029 1.86091C7.99972 1.72404 8.05089 1.4364 7.94452 1.21837C7.83816 1.00035 7.61467 0.93457 7.44514 1.07132L1.16971 6.13904C1.00028 6.2759 0.949114 6.56355 1.05548 6.78157C1.12425 6.92263 1.24212 7 1.36265 7Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/><path d="M8.4088 7H16.5912C16.817 7 17 6.77613 17 6.5C17 6.22387 16.817 6 16.5912 6H8.4088C8.18304 6 8 6.22387 8 6.5C8 6.77613 8.18304 7 8.4088 7Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/></svg>';

        var carouselNextIcon = '<svg width="19" height="14" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.3626 12C10.2421 12 10.1243 11.9226 10.0555 11.7816C9.94911 11.5635 10.0003 11.2758 10.1698 11.139L16.4452 6.07135C16.6147 5.93449 16.8383 6.00045 16.9445 6.21842C17.0509 6.4365 16.9997 6.72416 16.8302 6.86102L10.5548 11.9286C10.495 11.9769 10.4284 12 10.3626 12Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/><path d="M16.6374 7C16.5716 7 16.505 6.97693 16.4451 6.92863L10.1697 1.86091C10.0003 1.72404 9.94911 1.4364 10.0555 1.21837C10.1618 1.00035 10.3853 0.93457 10.5549 1.07132L16.8303 6.13904C16.9997 6.2759 17.0509 6.56355 16.9445 6.78157C16.8757 6.92263 16.7579 7 16.6374 7Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/><path d="M9.5912 7H1.4088C1.18304 7 1 6.77613 1 6.5C1 6.22387 1.18304 6 1.4088 6H9.5912C9.81696 6 10 6.22387 10 6.5C10 6.77613 9.81696 7 9.5912 7Z" fill="#151B26" stroke="#151B26" stroke-width="0.8"/></svg>';

        $('.single-author-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            fade: true,
            asNavFor: '.vr-testimonial-content-wrapper'
        });

        $('.vr-testimonial-content-wrapper').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.single-author-wrapper',
            dots: false,
            centerPadding: '0',
            centerMode: true,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="slick-prev">'+carouselPrevIcon+'</button>',
            nextArrow: '<button type="button" class="slick-next">'+carouselNextIcon+'</button>'
        });

        //-------pricing page testimonial---------
        $('.pricing-testimonial-wrapper').slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: false,
            centerPadding: '140px',
            centerMode: true,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="slick-prev">'+carouselPrevIcon+'</button>',
            nextArrow: '<button type="button" class="slick-next">'+carouselNextIcon+'</button>',
            responsive: [
                {
                  breakpoint: 575,
                  settings: {
                    centerPadding: '0',
                    centerMode: false,
                    slidesToShow: 1
                  }
                },
                {
                  breakpoint: 767,
                  settings: {
                    centerPadding: '40px',
                    slidesToShow: 1
                  }
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 1
                  }
                },
                {
                  breakpoint: 1300,
                  settings: {
                    slidesToShow: 2
                  }
                },
                {
                  breakpoint: 1700,
                  settings: {
                    slidesToShow: 3
                  }
                }
            ]
        });

        //---add aria-label to owl carousel dots-----
        $('.owl-carousel').each(function() {
            $(this).find('.owl-dot').each(function(index) {
                $(this).attr('aria-label', 'item-' + index);
            });
        });

        //-------- wpfm testimonial carousel-------------
        $(".wpfm-testimonial-wrapper").owlCarousel({
            loop: false,
            responsiveClass:true,
            items: 2,
            autoplay: true,
            smartSpeed: 2000,
            autoplayHoverPause: true,
            dots: false,
            nav: false,
            responsive:{
                0:{
                    items:1
                },
                576:{
                    items:1,
                },
                767:{
                    items:1,
                },
                992:{
                    items:2
                }
            }
        });

        //-------- wpfm landing testimonial carousel-------------
        $(".wpfm-landing-testimonial__wrapper").owlCarousel({
            loop: false,
            responsiveClass:true,
            items: 2,
            autoplay: false,
            smartSpeed: 2000,
            autoplayHoverPause: true,
            dots: false,
            nav: false,
            responsive:{
                0:{
                    items:1
                },
                576:{
                    items:1,
                },
                767:{
                    items:1,
                },
                992:{
                    items:3
                }
            }
        });

        //---------------scroll navigation of large blog table of content ---------------
        $(document).ready(function() {
            // Configuration
            const config = {
                tocLinkSelector: ".rex-scroll-navigation",
                headingSelector: ".rex-blog-details-content h2, .rex-blog-details-content h3",
                activeClass: "rex-blog-details-active",
                activeColor: "#201cfe",
                scrollOffset: 10,
                smoothScrollDuration: 800, // Adjusted for better UX
                throttleDelay: 50
            };

            // Add CSS for active state styling
            $("<style>")
            .text(`
                .${config.activeClass} {
                    color: ${config.activeColor} !important;
                    font-weight: 500 !important;
                }
            `)
            .appendTo("head");

            // Cache elements
            const $tocLinks = $(config.tocLinkSelector);
            const $headings = $(config.headingSelector);

            // Ensure headings have unique IDs
            $headings.each(function(index) {
                if (!this.id) {
                    const headingText = $(this).text().trim();
                    this.id = headingText
                    ? headingText.toLowerCase().replace(/[^a-z0-9]+/g, '-')
                    : `section-${index + 1}`;
                }
            });

            // Create mapping of heading IDs to ToC links
            const idToTocLinkMap = {};
            $tocLinks.each(function() {
                const targetId = $(this).attr("href").substring(1);
                idToTocLinkMap[targetId] = $(this);
            });

            // Smooth scroll on ToC click
            $(document).on("click", config.tocLinkSelector, function(event) {
                const targetId = $(this).attr("href");
                const $target = $(targetId);

                if ($target.length) {
                    event.preventDefault();

                    $("html, body").animate(
                        {
                            scrollTop: $target.offset().top - config.scrollOffset,
                        },
                        config.smoothScrollDuration
                    );

                    // Manually set active class to clicked item
                    $tocLinks.removeClass(config.activeClass);
                    $(this).addClass(config.activeClass);
                }
            });

            // IntersectionObserver to track visibility
            if ('IntersectionObserver' in window) {
                const observerOptions = {
                    root: null,
                    rootMargin: "-10% 0px -80% 0px", // Trigger near the top
                    threshold: [0, 0.1, 0.5]
                };

                const observer = new IntersectionObserver((entries) => {
                    let activeId = null;

                    entries.forEach(entry => {
                        const id = entry.target.id;

                        if (entry.isIntersecting) {
                            activeId = id;
                        }
                    });

                    // Activate the first visible heading
                    if (activeId && idToTocLinkMap[activeId]) {
                        $tocLinks.removeClass(config.activeClass);
                        idToTocLinkMap[activeId].addClass(config.activeClass);
                    }
                }, observerOptions);

                // Observe all headings
                $headings.each(function() {
                    observer.observe(this);
                });
            } else {
                // Fallback: Scroll event-based active state update
                function updateActiveItem() {
                    let scrollPosition = $(window).scrollTop();
                    let activeId = null;

                    $headings.each(function() {
                        const id = this.id;
                        const top = $(this).offset().top - config.scrollOffset;
                        const bottom = top + $(this).outerHeight();

                        if (scrollPosition >= top && scrollPosition < bottom) {
                            activeId = id;
                            return false;
                        }
                    });

                    if (activeId && idToTocLinkMap[activeId]) {
                        $tocLinks.removeClass(config.activeClass);
                        idToTocLinkMap[activeId].addClass(config.activeClass);
                    }
                }

                $(window).on("scroll", updateActiveItem);
                updateActiveItem();
            }
        });


        //-------- USA merchant carousel-------------
        $(".usa-wpfm-single-wrapper").owlCarousel({
            loop:true,
            items: 4,
            responsiveClass:true,
            autoplay: true,
            autoWidth:true,
            smartSpeed: 2000,
            autoplayHoverPause: true,
            dots: false,
            nav: true,
            navText: ["<div class='nav-button owl-prev'></div>",'<div class="nav-button owl-next"><svg width="31" height="19" viewBox="0 0 31 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M28.6259 8.01694C26.3463 7.09812 21.3188 5.55978 18.3926 2.05559C16.4671 -0.257473 15.4712 0.46729 17.1719 2.93512C18.4197 4.73996 18.6403 6.54153 20.9724 7.64682C18.2433 7.64722 20.6994 7.365 4.1871 7.82335C0.867538 7.92156 0.488186 8.18453 0.909303 9.09561C1.45743 10.2335 2.31316 10.821 3.44591 10.8307C3.47488 10.8295 22.6332 10.7986 22.6361 11.1614C22.6388 11.2193 22.1755 11.5442 21.5989 11.9317C17.6579 14.5097 16.2113 16.7342 17.7472 17.8881C18.4704 18.4379 19.7811 17.9175 22.0074 16.2111C22.9316 15.5039 25.1262 14.0456 26.9029 12.9536C31.3999 10.1631 31.7197 9.2639 28.6259 8.01694Z" fill="white"/></svg></div>'],
            responsive:{
                0:{
                    items:1,
                    nav: false,
                    autoWidth:false,
                },
                576:{
                    items:1,
                    nav: false,
                    autoWidth:false,
                },
                767:{
                    items:3,
                    nav: false,
                    // autoWidth:false,
                },

                992:{
                    items:4,
                    nav: false,
                    // autoWidth:false,
                },
                1280: {
                    items:4,
                },
                1440: {
                    items:4
                }

            }

        });

        //---------------scroll navigation of large blog table of content ---------------
        $(".scroll-navigation").on("click", function (event) {
            var target = $($(this).attr("href"));
            if (target.length) {
                event.preventDefault();
                $("html, body").animate({
                    scrollTop: target.offset().top - 0 + 'px',
                }, 1200);
            }
        });

        /* TOC - Rex dropdown  */
        $("#rex-toc .table-of-content > li > i").click(function(){
            $(this).siblings(".children").slideToggle(200);
            $(this).toggleClass('active');
            $(this).parents('li').siblings().find(".children").slideUp(200);
            $(this).parents('li').siblings().find("i").removeClass('active');
        });

        /*---reset password strength check----*/
        $("#resetPasswordForm #pass1").on("keyup",function(){
            var number = /([0-9])/;
            var alphabets = /([a-zA-Z])/;
            var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
            var submit_btn = $('#resetPasswordForm .submit #wp-submit');

            var pass1Val = $('#resetPasswordForm #pass1').val();
            var pass2Val = $('#resetPasswordForm #pass2').val();

            if ($('#resetPasswordForm #pass1').val().length < 6) {
                $('.password-strength-status').html("Weak: password should be atleast 6 characters.");
                $('.password-strength-status').removeClass("warn");
                $('.password-strength-status').removeClass("success");
                $('.password-strength-status').addClass("error");
                submit_btn.attr('disabled', true);

            } else {
                if ($('#resetPasswordForm #pass1').val().match(number) && $('#resetPasswordForm #pass1').val().match(alphabets) && $('#resetPasswordForm #pass1').val().match(special_characters)) {
                    $('.password-strength-status').html("Password strong");
                    $('.password-strength-status').removeClass("warn");
                    $('.password-strength-status').removeClass("error");
                    $('.password-strength-status').addClass("success");

                } else {
                    $('.password-strength-status').html("Medium: should include alphabets, numbers and special characters.");
                    $('.password-strength-status').removeClass("error");
                    $('.password-strength-status').removeClass("success");
                    $('.password-strength-status').addClass("warn");
                }
            }

            if(pass1Val == pass2Val){
                submit_btn.attr('disabled', true);
            }

            if (!$(this).val()){
                $('.password-strength-status').empty();
                $('.password-match-status').empty();
                $('.password-strength-status').removeClass("warn", "error", "success");
                submit_btn.attr('disabled', true);
            }
        });

        /*---check reset password matched---*/
        $("#resetPasswordForm #pass2").on("keyup",function(){
            var pass1Val = $('#resetPasswordForm #pass1').val();
            var pass2Val = $('#resetPasswordForm #pass2').val();
            var submit_btn = $('#resetPasswordForm .submit #wp-submit');

            if(pass1Val == pass2Val){
                submit_btn.attr('disabled', false);
                $('.password-match-status').html("Password matched.");
                $('.password-match-status').removeClass("error").addClass("success");
            }
            else{
                submit_btn.attr('disabled', true);
                $('.password-match-status').html("Password doesn't matched.");
                $('.password-match-status').removeClass("success").addClass("error");
            }
            if (!$(this).val()){
                submit_btn.attr('disabled', true);
                $('.password-match-status').empty();
                $('.password-match-status').removeClass("error", "success");
            }
        });

        // for lost password
        $("form#lostpasswordform").on("submit",function(e){
            e.preventDefault();
            var submit = $("div#lostPassword #submit"),
                preloader = $("#lostpasswordform .submit .fa-spinner"),
                message	= $("div#lostPassword #message"),
                contents = {
                    action: 	'lost_pass',
                    nonce: 		this.rex_user_lost_password_nonce.value,
                    user_login:	this.user_login.value
                };

            // disable button onsubmit to avoid double submission
            submit.attr("disabled", "disabled").addClass('disabled');

            // Display pre-loading
            preloader.css({'display':'inline-block'});

            jQuery.ajax({
                type : "post",
                dataType : "json",
                url : rextheme_ajax.url,
                data : {
                    action: "lost_pass",
                    user_login:	this.user_login.value,
                    nonce: this.rex_user_lost_password_nonce.value
                },
                success: function(response) {
                    $('.reset-success-msg').text(response.message);

                    if(response.error){
                        $('.reset-success-msg').addClass('error');
                    }else{
                        $('.reset-success-msg').removeClass('error');
                        $('#wp-submit').attr('disabled',true);
                    }
                },
                complete: function(){
                    preloader.css({'display':'none'});
                },
                error: function (response) {

                }
            });
            return false;
        });

        // for reset password
        $("form#resetPasswordForm").on("submit",function(e){
            e.preventDefault();
            var submit = $("div#resetPassword #submit"),
                message	= $("div#resetPassword #message"),
                contents = {
                    action: 	'reset_pass',
                    nonce: 		this.rex_user_lost_password_nonce.value,
                    pass1:		this.pass1.value,
                    pass2:		this.pass2.value,
                    user_key:	this.user_key.value,
                    user_login:	this.user_login.value
                };

            // disable button onsubmit to avoid double submission
            submit.attr("disabled", "disabled").addClass('disabled');

            jQuery.ajax({
                type : "post",
                dataType : "json",
                url : rextheme_ajax.url,
                data : {
                    action: "reset_pass",
                    pass1:		this.pass1.value,
                    pass2:		this.pass2.value,
                    user_key:	this.user_key.value,
                    user_login:	this.user_login.value,
                    nonce: this.rex_user_lost_password_nonce.value
                },
                success: function(response) {
                    $('.reset-success-msg').text(response.message);
                    $('#wp-submit').attr('disable', true);
                },
                error: function (response) {

                }
            });
            return false;
        });

        //--------Scroll Top---------
        $('.scroll-top').on('click', function (event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: 0
            }, 500);
        });

        //-------------- Counter Black Friday Campaign ---------
        if($(".rextheme__notification-counter").length > 0 ){
            const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;

            let now = new Date().getTime();
            const countDown = new Date( '12/26/2023 00:00:00' ).getTime(),
            x = setInterval(function() {
                const distance = countDown - now;
                now = now + 1000;

                let formattedDay = Math.floor(distance / (day)),
                    formattedHours = Math.floor((distance % (day)) / (hour)),
                    formattedMin =  Math.floor((distance % (hour)) / (minute));

                $("#rextheme__days").text( formattedDay.toString().length > 1 ? formattedDay : '0' + formattedDay.toString() );
                $("#rextheme__hours").text( formattedHours.toString().length > 1 ? formattedHours : '0' + formattedHours.toString() );
                $("#rextheme__mins").text( formattedMin.toString().length > 1 ? formattedMin : '0' + formattedMin.toString() );

                // do something later when date is reached
                if ( 0 >= distance ) {
                    document.querySelector(".rextheme__notification-counter").style.display = "none";
                    clearInterval(x);
                }
                //seconds
            }, 1000);

        }

        //-------------- Black Friday landing page Scroll to down ---------
        $(' a.bf-hero__button').click(function(event) {

            event.preventDefault();
            var id = $(this).attr("href");
            var target = $(id);

            let dataTarget = $(this).attr('data-target');

            if($(window).width() < 992) {
                $('.pricing-tbl-navbar li[data-target="'+dataTarget+'"]').parents('.slick-slide').siblings().find('li').removeClass('active');
                $('.pricing-tbl-navbar li[data-target="'+dataTarget+'"]').addClass('active');
            } else {
                $('.pricing-tbl-navbar li[data-target="'+dataTarget+'"]').siblings().removeClass('active');
                $('.pricing-tbl-navbar li[data-target="'+dataTarget+'"]').addClass('active');
            }

            $('.single-price-tab-content.'+dataTarget).siblings().hide();
            $('.single-price-tab-content.'+dataTarget).show();

            $('html, body').animate({
                scrollTop:target.offset().top
            }, {
                duration: 1500,
                step: function( now, fx ) {
                    var newOffset = target.offset().top;
                    if(fx.end !== newOffset)
                        fx.end = newOffset;
                }
            });

        });


        /**
         * Checks if an element is in the viewport.
         *
         * @param {Element[]} element - The element to check.
         * @return {boolean} Returns true if the element is in the viewport, false otherwise.
         */
        function isInViewport(element, topDistance = 0.85) {
            if(element.length > 0) {
                const rect = element[0].getBoundingClientRect();
                const windowHeight = window.innerHeight || document.documentElement.clientHeight;
                const topThreshold = windowHeight * topDistance; // 85% from the top

                return rect.top <= topThreshold && rect.bottom >= 0;
            }
        }

        $(window).on('scroll', function() {
            if ($(this).scrollTop() > 100) {
                $('.rex-price-sticky-area').css('top','100px');
            }else{
                $('.rex-price-sticky-area').css('top','371px');
            }
            if (isInViewport($('.pricing-section.rex-dynamic-pricing')) || isInViewport($('section.rex-compatible-area')) || isInViewport($('section.rex-related-area')) || isInViewport($('footer'))) {
              $('.rex-price-sticky-area').fadeOut(300);
            } else {
              $('.rex-price-sticky-area').fadeIn(300);
            }
        });

        if (isInViewport($('.pricing-section.rex-dynamic-pricing')) || isInViewport($('section.rex-compatible-area')) || isInViewport($('section.rex-related-area')) || isInViewport($('footer'))) {
            $('.rex-price-sticky-area').fadeOut(500);
        } else {
            $('.rex-price-sticky-area').fadeIn(500);
        }

        $('.rex-pricing-product-faq .card .card-header,.rex-faq-content-area .card .card-header,#wpvr-accordion .card .card-header').on('click', function() {
            // Remove 'active' class from all cards except the clicked one
            $(this).closest('.card').siblings().removeClass('active');

            // Toggle 'active' class for the clicked card
            $(this).closest('.card').toggleClass('active');
        });

        // Function to update navigation based on scroll position
        function updateNavigation() {
            var sections = $('section');
            sections.each(function() {
            var sectionTop = $(this).offset().top - $(window).height() / 8;
            var sectionBottom = sectionTop + $(this).outerHeight();
            var scrollPosition = $(window).scrollTop();

            if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
                var id = $(this).attr('id');
                $('li a').removeClass('active');
                $('li a[href="#' + id + '"]').addClass('active');
            }
            });
        }

        // Update navigation on scroll
        $(window).scroll(function() {
            updateNavigation();
        });

        // Update navigation on page load
        updateNavigation();

        //------wpvr home page text and image slide animation-------
        var $slider = $('.wpvr-text-slide-nav');
        var slideDuration = 4000;

        function resetProgressBar($progressBar) {
            $progressBar.css('width', '0').css('transition', 'width 0s linear');
        }

        function startProgressBar($progressBar) {
            setTimeout(function() {
                $progressBar.css('transition', 'width ' + (slideDuration / 1000) + 's linear').css('width', '100%');
            }, 50);
        }

        $slider.on('init', function(event, slick){
            var $firstSlideProgressBar = $(slick.$slides[0]).find('.progress-bar');
            startProgressBar($firstSlideProgressBar);
        });

        $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
            var $currentSlideProgressBar = $(slick.$slides[currentSlide]).find('.progress-bar');
            var $nextSlideProgressBar = $(slick.$slides[nextSlide]).find('.progress-bar');

            resetProgressBar($currentSlideProgressBar);
            startProgressBar($nextSlideProgressBar);
        });

        $('.wpvr-text-slide-for').slick({
            slidesToShow: 1,
            autoplay: true,
            infinite: true,
            slidesToScroll: 1,
            arrows: false,
            autoplaySpeed: slideDuration,
            dots: false,
            fade: true,
            draggable: true,
            swipeToSlide: false,
            asNavFor: '.wpvr-text-slide-nav'
        });

        $('.wpvr-text-slide-nav').slick({
            slidesToShow: 1,
            autoplay: true,
            infinite: true,
            autoplaySpeed: slideDuration,
            slidesToScroll: 1,
            asNavFor: '.wpvr-text-slide-for',
            dots: false,
            vertical: true,
            verticalScrolling: true,
            centerMode: true,
            arrows: false,
            draggable: false,
            swipeToSlide: false,
        });

        // ------wpvr mobile menu dropdown------
        $(document).on("click",".header-wpvr .menu-item-has-children",function() {
            $(this).toggleClass('active').siblings().removeClass('active');

            $(this).siblings().children('.dropdown-menu').slideUp();
            $(this).children('.dropdown-menu').slideToggle();
        });

        //------on mobile hamburger click remove .navbarpwrapper shadow------
        $(document).on("click",".header-wpvr .navbar-toggler",function() {
            $(this).parents('.navbar-wrapper').toggleClass('shadow-none');
        });

        // ------wpvr home page steps tab behavior------
        $(document).on("click",".wpvr-steps .wpvr-single-step",function() {
            let target = $(this).attr('data-target');

            $(this).addClass('active').siblings().removeClass('active');
            $(this).siblings().children('p').slideUp();
            $(this).children('p').slideDown();

            $('.wpvr-single-step-img.'+target).siblings().removeClass('active');
            $('.wpvr-single-step-img.'+target).addClass('active');

            $('.wpvr-single-step-img.'+target).siblings().find('figure').hide();
            $('.wpvr-single-step-img.'+target).find('figure').show();
        });

        // -------wpvr home page industries tab behavior------
        $(document).on("click",".wpvr-industries .single-industry-nav-item",function() {
            let target = $(this).attr('data-target');

            $(this).addClass('active').siblings().removeClass('active');

            $('.wpvr-industries .single-industry.'+target).siblings().css('display','none').removeClass('active');
            $('.wpvr-industries .single-industry.'+target).css('display','flex').addClass('active');
        });

        // -------wpvr custom modal------
        $(document).on("click",".wpvr-openModal",function(e) {
            e.preventDefault();
            e.stopPropagation();

            let iframeElement = $(this).attr('data-iframe');

            $('#wpvr-modal').attr("aria-hidden", "false").addClass('show');
            $('#wpvr-iframe-video').html(iframeElement);

        });

        $(document).on("click",".wpvr-modal-content",function(e) {
            e.stopPropagation();
        });

        $(document).on("click",".wpvr-closeModal, body",function() {
            $('#wpvr-modal').attr("aria-hidden", "true").removeClass('show');
            $('#wpvr-iframe-video').html('');
        });

        //--------wpvr home page demo tour change------
        $(document).on("click",".demo-tour-list .wpvr-selectbox-options li.option",function() {
            let iframe = $(this).attr('data-value');
            $('.wpvr-demo-tour .wpvr-demo-tour-wrapper').html('');
            $('.wpvr-demo-tour .wpvr-demo-tour-wrapper').html(iframe);
        });

        //--------wpvr feature page controls marquee behavior------
        let items = $('.wpvr-controls-wrapper .single-control').clone();
        $('.wpvr-controls-wrapper').append(items);

        // ------window on scroll add class to comparison table header------
        $(window).on('scroll', function() {
            if ($('.comparison-tbl-header').length > 0){

                let header = $('.comparison-tbl-header');
                let headerOffset = header.offset().top - $(window).scrollTop();

                if (headerOffset === 0) {
                    header.addClass('sticked');
                } else {
                    header.removeClass('sticked');
                }

            }


        });

        //---------home page on scroll animation------
        $(window).on('scroll', function() {
            if( isInViewport($('.wpvr-key-feature .feature-2 .hotspot-1'), 0.8) ) {
                $('.wpvr-key-feature .feature-2 .hotspot-1').addClass('wpvr-animated');
            }else{
                $('.wpvr-key-feature .feature-2 .hotspot-1').removeClass('wpvr-animated');
            }

            if( isInViewport($('.wpvr-key-feature .feature-4 .hotspot-3'), 0.9) ) {
                $('.wpvr-key-feature .feature-4 .hotspot-3').addClass('wpvr-animated');
            }else{
                $('.wpvr-key-feature .feature-4 .hotspot-3').removeClass('wpvr-animated');
            }

            let hotspots2 = $('.wpvr-special-feature .feature-1 .hotspot-1, .wpvr-special-feature .feature-2 .hotspot-1');
            if( isInViewport(hotspots2, 0.7) ) {
                hotspots2.addClass('wpvr-animated');
            }else{
                hotspots2.removeClass('wpvr-animated');
            }

            let hotspots3 = $('.wpvr-special-feature .feature-3 .hotspot-1, .wpvr-special-feature .feature-5 .hotspot-1');
            if( isInViewport(hotspots3, 0.7) ) {
                hotspots3.addClass('wpvr-animated');
            }else {
                hotspots3.removeClass('wpvr-animated');
            }

        });

        $(window).on('scroll', function() {
            //---------features page on scroll animation------
            if( $('.wpvr-single-image-content-block .wpvr-hotspot').length > 0) {
                $(".wpvr-single-image-content-block .wpvr-hotspot").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }

            //---------realestate page on scroll animation------
            if( $('.wpvr-realestate-single-feature .wpvr-hotspot').length > 0) {
                $(".wpvr-realestate-single-feature .wpvr-hotspot").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }
            if( $('.wpvr-realestate-single-feature .feature-image2').length > 0) {
                $(".wpvr-realestate-single-feature .feature-image2").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }

            if( $('.wpvr-realestate-single-share .wpvr-hotspot').length > 0) {
                $(".wpvr-realestate-single-share .wpvr-hotspot").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }
            if( $('.wpvr-realestate-single-share .feature-image2').length > 0) {
                $(".wpvr-realestate-single-share .feature-image2").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }

            //-----hotel tour page on scroll animation------
            if( $('.wpvr-hotel-tour-single-share .feature-image2').length > 0) {
                $(".wpvr-hotel-tour-single-share .feature-image2").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }

            //-----hotspot feature page hero scroll animation------
            if( $('.wpvr-feature-hero-image .wpvr-hotspot').length > 0) {
                $(".wpvr-feature-hero-image .wpvr-hotspot").each(function(){
                    if( isInViewport( $(this), 0.85) ) {
                        $(this).addClass('wpvr-animated');
                    }else{
                        $(this).removeClass('wpvr-animated');
                    }
                });
            }


        });

        //-------checkout page orderbump tab behavior------
        $(document).on("click",".rex-orderbump-tab-nav > li",function() {
            let dataTarget = $(this).attr('data-target');
            $(this).addClass('active').siblings().removeClass('active');
            $(this).parents('.rex-orderbump').find('.orderbump-single-price.'+dataTarget).siblings('.orderbump-single-price').hide();
            $(this).parents('.rex-orderbump').find('.orderbump-single-price.'+dataTarget).show();

            if('lifetime-plan' === dataTarget) {
                $(this).parents('.rex-orderbump').find('.rex-orderbump-tab-content').addClass('top-left-radius');
            } else {
                $(this).parents('.rex-orderbump').find('.rex-orderbump-tab-content').removeClass('top-left-radius');
            }
        });


        //-------checkout page orderbump tab behavior------
        $(document).on("click", "label.rex-orderbump-single-price-plan", function() {
          $('.rex-orderbump .rex-dynamic-price-btn').hide()
          // Set data-checked attribute
          $(this).find('input[type="radio"]').prop('checked', true).attr('data-checked', 'true').closest('label').siblings().find('input[type="radio"]').attr('data-checked', 'false');

          // Get the data URL from the checked radio button
          let dataUrl = $(this).find('input[type="radio"]').val();
          let isChecked = $(this).find('input[type="radio"]').attr('data-checked');

          // Toggle the button visibility based on the checked state
          if (dataUrl && isChecked === 'true') {
            $(this).parents('.rex-orderbump').find('.rex-dynamic-price-btn').show();
          }

          // Set the URL for the purchase button
          $(this).parents('.rex-orderbump').find('.rex-dynamic-price-btn .rex-cart-btn').attr('href', dataUrl);
        });


        $('.rex-faq-accordion .card-header .btn').on('click', function() {
            $(this).parents('.card').toggleClass('active').siblings().removeClass('active');
        });

        /**
         * A function that checks the distance from the top of each element with the class 'rex-single-plugin' and adds or removes the 'stickied' class based on the distance.
         */
        function checkDistance() {
            $('.rex-plugins-area .rex-single-plugin').each(function() {
                var distanceFromTop = $(this).offset().top - $(window).scrollTop();

                if (distanceFromTop === 30) {
                    $(this).addClass('stickied');
                } else {
                    $(this).removeClass('stickied');
                }
            });
        }

        // Run the checkDistance function on load, resize, and scroll
        $(window).on('load resize scroll', checkDistance);

        $(document).on("click", ".brand-assets-tav-nav li", function(e) {
            e.preventDefault();

            const $this = $(this);
            const $parentHero = $this.closest('.rex-brand-assets-hero');

            // Get data target value
            const dataTarget = $this.attr('data-target');
            if (!dataTarget) {
                console.warn('Missing data-target attribute on clicked element');
                return;
            }

            try {
                // First remove all active classes
                $('.brand-assets-tav-nav li').removeClass('active');
                $('.hero-content').removeClass('active');
                $('.rex-single-brand-asset').removeClass('active');

                // Then add active class to current elements
                $this.addClass('active');

                // Add active class to corresponding hero content
                $parentHero
                    .find(`.hero-content.plugin-${dataTarget}`)
                    .addClass('active');

                // Add active class to corresponding brand asset
                $(`.rex-brand-assets .rex-single-brand-asset.plugin-${dataTarget}`)
                    .addClass('active');

            } catch (error) {
                console.error('Error updating tab states:', error);
            }
        });


        // Wait for DOM to be fully loaded
        $(document).ready(function() {
            const slider = $('.brand-assets-slick-slider');

            // Safety check - ensure slider exists
            if (!slider.length) {
                console.warn('Brand assets slider not found on page');
                return;
            }

            // Count total slides
            const totalSlides = slider.children().length;

            // Default configuration for the slider
            const slickConfig = {
                infinite: true,
                slidesToShow: 6,
                slidesToScroll: 1,
                arrows: false,
                variableWidth: true,
                dots: false,
                autoplay: false,
                autoplaySpeed: 3000,
                pauseOnHover: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },

                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            infinite: true
                        }
                    }
                ]
            };

            // Initialize the slider
            try {
                slider.slick(slickConfig);
            } catch (error) {
                console.error('Error initializing slider:', error);
                return;
            }

            // Custom navigation buttons
            const navigation = $('<nav>')
                .addClass('slider-navigation')
                .attr('aria-label', 'Slider Navigation')
                .css({
                    'text-align': 'center',
                    'position': 'relative'
                });

                const prevButton = $('<button>')
                .addClass('slider-nav-btn prev')
                .attr({
                    'type': 'button',
                    'aria-label': 'Previous Slide'
                })
                .html('<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                      '<path d="M7 13L1 7L7 1" stroke="#201CFE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                      '</svg>')
                .on('click', () => slider.slick('slickPrev'));

                const nextButton = $('<button>')
                .addClass('slider-nav-btn next')
                .attr({
                    'type': 'button',
                    'aria-label': 'Next Slide'
                })
                .html(`<svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L7 7L1 13" stroke="#201CFE" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>`)
                .on('click', () => slider.slick('slickNext'));

                   // Function to update navigation visibility
                    function updateNavigation() {
                        const currentSlide = slider.slick('slickCurrentSlide');
                        const slidesToShow = slider.slick('slickGetOption', 'slidesToShow');

                        // Hide navigation if 6 or fewer total slides
                        if (totalSlides <= 6) {
                            navigation.hide();
                            return;
                        }

                        // Show/hide prev button
                        if (currentSlide === 0) {
                            prevButton.show();
                            prevButton.prop('disabled', true)
                            .css({
                                'cursor': 'not-allowed',
                                'opacity': 0.5
                            });

                        } else {
                            prevButton.show();
                            prevButton.prop('disabled', false)
                            prevButton.css({
                                'background-color': 'white',
                                'cursor': 'pointer',
                                'opacity': 1
                            });
                        }

                        // Show/hide next button and update its style
                        if (currentSlide >= totalSlides - slidesToShow) {
                            nextButton.prop('disabled', true)
                            nextButton.show();
                            nextButton.css({'cursor': 'not-allowed',
                                'opacity': 0.5
                            });

                        } else {
                            nextButton.prop('disabled', false)
                            nextButton.show();
                            nextButton.css({'background-color': 'white',
                                'cursor': 'pointer',
                                'opacity': 1
                            });
                        }
                    }

            navigation.append(prevButton, nextButton);
            // Add navigation and counter after the slider
            slider.after(navigation);

            // Update navigation on initialization and after slide changes
            updateNavigation();
            slider.on('afterChange', updateNavigation);

            // Update navigation on window resize
            $(window).on('resize', function() {
                setTimeout(updateNavigation, 150);
            });


            // Optional: Add keyboard navigation
            $(document).on('keydown', function (e) {
                if (!slider.is(':visible') || !slider.is(':focus')) return;
                if (e.keyCode === 37) slider.slick('slickPrev');
                else if (e.keyCode === 39) slider.slick('slickNext');
            });

            // Add touch swipe support for mobile
            slider.on('swipe', function(event, slick, direction) {
                console.log(`Swiped ${direction}`);
            });

        });

        //-------brand assets page copy to clipboard--------
        $('.asset-brand-color .asset-body button[type="button"]').on('click', function() {
            var inputField = $("<input>");
            $("body").append(inputField);
            inputField.val($(this).siblings('.asset-body > .color-code').text()).select();
            document.execCommand("copy");
            inputField.remove();

            $(this).parents('.single-asset').find('.copied-notice').fadeIn();

            setTimeout(function() {
            $('.copied-notice').fadeOut();
            }, 1500);

        });

        //-------megamenu hover overlay------
        if( $(window).width() > 1199 ) {
            $(document).on("mouseleave",".rex-navbar .navbar-nav > li.rex-megamenu-item", function() {
                var siteMainOffsetTop = $('main.site-main').offset().top;

                var $overlay = $('<div id="megamenu-hover-overlay"></div>').css({
                    position: 'fixed',
                    top: siteMainOffsetTop,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0)',
                    zIndex: 9999
                }).appendTo('body');

                setTimeout(function(){
                    $overlay.remove();
                }, 500)

            })
        }

        /**
         * Retrieves the value of a URL parameter.
         *
         * @param {string} name - The name of the parameter to retrieve.
         * @return {string} The value of the parameter, or an empty string if the parameter is not found.
         */
        function getUrlParameter(name) {
            name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
            var results = regex.exec(location.search);
            return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
        }

        // Get the 'assets' parameter from the URL
        var assetsParam = getUrlParameter('assets');

        // Add active class on brand assets tab nav
        $('.rex-brand-assets-hero .hero-content.plugin-'+assetsParam+'').addClass('active').siblings().removeClass('active');

        $('.brand-assets-tav-nav > li[data-target="'+assetsParam+'"]').addClass('active').siblings().removeClass('active');

        $('.rex-single-brand-asset.plugin-'+assetsParam+' ').addClass('active').siblings().removeClass('active');


        // --------rextheme home page product tab carousel from 991--------
        if( $(window).width() < 992 ) {
            $('.home-product-tab-nav').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                centerPadding: '0',
                centerMode: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#D3D2FF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 13l6-6-6-6"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#D3D2FF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 13l6-6-6-6"/></svg></button>',
                responsive: [
                    {
                      breakpoint: 425,
                      settings: {
                        slidesToShow: 3
                      }
                    },
                    {
                      breakpoint: 576,
                      settings: {
                        slidesToShow: 4
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 3
                      }
                    },

                ]
            });
        }

        // --------rextheme black friday pricing product tab carousel from 991--------
        if( $(window).width() < 992 ) {
            $('.bf-2024-pricing .pricing-tbl-navbar,.cm-2024-pricing .pricing-tbl-navbar').slick({
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                centerPadding: '0',
                centerMode: false,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#D3D2FF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 13l6-6-6-6"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#D3D2FF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 13l6-6-6-6"/></svg></button>',
                responsive: [
                    {
                      breakpoint: 425,
                      settings: {
                        slidesToShow: 3
                      }
                    },
                    {
                      breakpoint: 576,
                      settings: {
                        slidesToShow: 4
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 3
                      }
                    },

                ]
            });
        }

        // --------rextheme black friday pricing and christmas hero testimonial slider from 991--------
        if( $(window).width() < 992 ) {
            $('.bf-hero__content .bf-testimonial-wrapper,.cm-hero__content .cm-testimonial-wrapper').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                centerPadding: '0',
                centerMode: false,
                focusOnSelect: true,
                prevArrow: '',
                nextArrow: '',
                responsive: [
                    {
                      breakpoint: 425,
                      settings: {
                        slidesToShow: 1
                      }
                    },
                    {
                      breakpoint: 576,
                      settings: {
                        slidesToShow: 1,
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                      }
                    },

                ]
            });
        }

        //-------rextheme home page testimonial carousel------
        $('.rextheme-home-testimonial-wrapper').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            centerPadding: '0',
            centerMode: true,
            focusOnSelect: true,
            prevArrow: '<button type="button" class="slick-prev"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#201CFE" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 13L1 7l6-6"/></svg></button>',
            nextArrow: '<button type="button" class="slick-next"><svg width="8" height="14" fill="none" viewBox="0 0 8 14" xmlns="http://www.w3.org/2000/svg"><path stroke="#201CFE" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 13l6-6-6-6"/></svg></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                    slidesToShow: 1
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                    slidesToShow: 2
                    }
                },

            ]
        });


        /**
         * Checks if an element is in the viewport and add 'active' class. If not in viewport, remove 'active' class.
         * Retrieves the value of the 'data-line' attribute from the current element.
         *
         * @type {string} dataLine - The value of the 'data-line' attribute.
         */
        $(window).on('scroll', function() {
            if( isInViewport($('.rextheme-products-logo'), 0.8) ) {
                $('.rextheme-products-logo').addClass('active');

            }else{
                $('.rextheme-products-logo').removeClass('active');
            }

        });

        //----add slick carousel navigation button accecible name-----
        if($('.slick-prev').length){
            $('.slick-prev').attr('aria-label','Previous');
        }

        if($('.slick-next').length){
            $('.slick-next').attr('aria-label','Next');
        }

        // ------black friday landing testimonial tab behavior------
        $(document).on("click",".bf-testimonial-tab-nav> li", function() {
            let dataTarget = $(this).attr('data-target');
            $(this).addClass('active').siblings().removeClass('active');
            $('.bf-testimonial-tab-content .'+dataTarget).addClass('active').siblings().removeClass('active');

            if( $(window).width() < 992 ) {
                $('.bf-single-product-testimonial .bf-testimonial-wrapper').slick("refresh");
            }
        })

        // ------christmas landing testimonial tab behavior------
        $(document).on("click",".cm-testimonial-tab-nav> li", function() {
            let dataTarget = $(this).attr('data-target');
            $(this).addClass('active').siblings().removeClass('active');
            $('.cm-testimonial-tab-content .'+dataTarget).addClass('active').siblings().removeClass('active');

            if( $(window).width() < 992 ) {
                $('.cm-single-product-testimonial .cm-testimonial-wrapper').slick("refresh");
            }
        })

        // --------black friday landing testimonial carousel from 991--------
        if( $(window).width() < 992 ) {
            $('.bf-single-product-testimonial .bf-testimonial-wrapper,.cm-single-product-testimonial .cm-testimonial-wrapper').slick({
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                autoplay: true,
                dots: false,
                arrows: false,
                centerPadding: '0',
                centerMode: false,
                focusOnSelect: true,
                responsive: [
                    {
                      breakpoint: 576,
                      settings: {
                        slidesToShow: 1
                      }
                    }

                ]
            });
        }


    }); //---end document ready---

    document.addEventListener("DOMContentLoaded", function() {
        setTimeout(function(){
            $('.rextheme-products-logo').addClass('active');
        }, 1200);

        // Ensure there are products to clone
        if (document.querySelectorAll('.bf-hero__product-discount a').length > 0) {
            const productItems = document.querySelectorAll('.bf-hero__product-discount a');
            const container = document.querySelector('.bf-hero__product-discount');

            productItems.forEach(item => {
                const clone = item.cloneNode(true);
                container.appendChild(clone);
            });

            container.offsetHeight;
            container.style.animation = 'none';
            setTimeout(() => {
                container.style.animation = '';
            }, 10);
        }

    });

    //--------wpvr features page hero tab behavior (vanilla js version)------
    document.addEventListener("DOMContentLoaded", function() {
        if (document.querySelectorAll('.wpvr-feature-tab-nav .wpvr-single-feature-item').length > 0){
            // Get all feature items
            var featureItems = document.querySelectorAll('.wpvr-feature-tab-nav .wpvr-single-feature-item');
            featureItems.forEach(function(item) {
                var imgUrl = item.getAttribute('img-url');
                var dataItem = item.getAttribute('data-item');

                setTimeout(function(){
                    var featureImage = document.querySelector('.wpvr-single-feature-tab-content.feature-item-' + dataItem + ' .feature-image > img');
                    if (featureImage) {
                        featureImage.setAttribute('src', imgUrl);
                    }
                }, 1000);
            });

            // Add click event listener to each feature item
            document.querySelectorAll(".wpvr-feature-tab-nav .wpvr-single-feature-item").forEach(function(item) {
                item.addEventListener("click", function() {
                    var dataItem = this.getAttribute('data-item');

                    // Add active class to the clicked item and remove from siblings
                    featureItems.forEach(function(sibling) {
                        sibling.classList.remove('active');
                    });
                    this.classList.add('active');

                    // Show the corresponding content and hide others
                    var contents = document.querySelectorAll('.wpvr-single-feature-tab-content');
                    contents.forEach(function(content) {
                        if (content.classList.contains('feature-item-' + dataItem)) {
                            content.style.display = 'block';
                            content.classList.add('active');
                        } else {
                            content.style.display = 'none';
                            content.classList.remove('active');
                        }
                    });
                });
            });
        }

    });

    //--------wpvr home page industries image load after 1sec behavior------
    document.addEventListener("DOMContentLoaded", function() {
        if (document.querySelectorAll('.industries-tab-nav .single-industry-nav-item').length > 0){
            // Get all feature items
            var featureItems = document.querySelectorAll('.industries-tab-nav .single-industry-nav-item');
            featureItems.forEach(function(item) {
                var imgUrl = item.getAttribute('img-url');
                var dataItem = item.getAttribute('data-item');

                setTimeout(function(){
                    var featureImage = document.querySelector('.single-industry.industry-' + dataItem + ' .industry-image figure > img');
                    if (featureImage) {
                        featureImage.setAttribute('src', imgUrl);
                    }
                }, 1000);
            });

        }

        // Find the element with the class .affwp-hidden inside .affwp-campaign-wrap
        var campaignWrap = document.querySelector('.affwp-campaign-wrap.affwp-hidden');
        if (campaignWrap) {
            // Toggle the display property
            if (campaignWrap.style.display === 'block') {
                campaignWrap.style.display = 'none';
            } else {
                campaignWrap.style.display = 'block';
            }
        }

    });

    //--------wpvr home page custom selectbox------
    document.addEventListener("DOMContentLoaded", () => {
        if (document.querySelectorAll('.wpvr-selectbox').length > 0){

            const selectMenu = document.querySelector(".wpvr-selectbox");
            const selectBtn = document.querySelector(".wpvr-selected-box");
            const options = document.querySelectorAll(".option");
            let selectedValue = null;

            selectBtn.addEventListener("click", () => {
                selectMenu.classList.toggle("active");
            });

            options.forEach(option => {
                option.addEventListener("click", () => {
                    const selectedText = option.querySelector(".option-text").innerText;
                    selectBtn.querySelector(".wpvr-selected-text").innerText = selectedText;
                    selectedValue = option.getAttribute("data-value");

                    // Remove selected class from all options
                    options.forEach(opt => opt.classList.remove("selected"));

                    // Add selected class to the clicked option
                    option.classList.add("selected");

                    // Close the dropdown
                    selectMenu.classList.remove("active");

                });
            });

            // close dropdown on body click
            document.addEventListener("click", (event) => {
                if (!selectBtn.contains(event.target) && !selectMenu.contains(event.target)) {
                    selectMenu.classList.remove("active");
                }
            });



        }

    });

    //--------rextheme home page product section tab behavior (vanilla js version)------
    document.addEventListener("DOMContentLoaded", function() {
        if (document.querySelectorAll('.home-product-tab-nav .single-product-item').length > 0){
            // Get all feature items
            var rexProductItem = document.querySelectorAll('.home-product-tab-nav .single-product-item');
            rexProductItem.forEach(function(item) {
                let imgUrl = item.getAttribute('img-url');
                let dataItem = item.getAttribute('data-item');

                setTimeout(function(){
                    let featureImage = document.querySelector('.product-single-tab-content.product-item-' + dataItem + ' .feature-image > img');
                    if (featureImage) {
                        featureImage.setAttribute('src', imgUrl);
                    }
                }, 1000);
            });

            // Add click event listener to each feature item
            document.querySelectorAll(".home-product-tab-nav .single-product-item").forEach(function(item) {
                item.addEventListener("click", function() {
                    let dataItem = this.getAttribute('data-item');

                    // Add active class to the clicked item and remove from siblings
                    rexProductItem.forEach(function(sibling) {
                        sibling.classList.remove('active');
                    });
                    this.classList.add('active');

                    // Show the corresponding content and hide others
                    var contents = document.querySelectorAll('.product-single-tab-content');
                    contents.forEach(function(content) {
                        if (content.classList.contains('product-item-' + dataItem)) {
                            content.style.display = 'block';
                            content.classList.add('active');
                        } else {
                            content.style.display = 'none';
                            content.classList.remove('active');
                        }
                    });
                });
            });
        }

    });

    //--------rextheme blog listing search section behavior (vanilla js version)------
    document.addEventListener('DOMContentLoaded', function() {
        const searchInput = document.getElementById('s');
        const clearIcon = document.getElementById('clear-search');

        if (searchInput && clearIcon) {  // Extra safety check
            searchInput.addEventListener('input', function() {
                if (searchInput.value.length > 0) {
                    clearIcon.style.display = 'block';
                } else {
                    clearIcon.style.display = 'none';
                }
            });

            clearIcon.addEventListener('click', function() {
                searchInput.value = '';
                searchInput.focus();
                clearIcon.style.display = 'none';
                document.getElementById('rex-blog-search-results').innerHTML = '';
            });

        } else {
            console.error('Elements not found: searchInput or clearIcon');
        }
    });

   //--------license key---------
    $(function() {
        $('.rex_edd_sl_license button').click(function() {
            $(this).focus();
            $(this).siblings("input").select();
            $(this).tooltip('show');
            document.execCommand('copy');
        });
    });

    // ------------active class for toc

    $(document).ready(function(){
        $('.rextheme-item a').on('click', function() {
            $(this).removeClass('rex-blog-details-active');
            $(this).addClass('rex-blog-details-active');
        });
    })

    $(document).ready(function() {
        $('section.rex-bundle-pricing-landing #annual-price .rex-dynamic-price-content-area').click(wcSellKitPricingHandle);

        $('section.rex-bundle-pricing-landing #lifetime-price .rex-dynamic-price-content-area').click(wcSellKitPricingHandle);

        $('#rex-price-sticky-area #annual-price .rex-dynamic-price-content-area').click(wcSellKitPricingHandle);

        $('aside#rex-price-sticky-area #lifetime-plan .rex-dynamic-price-content-area').click(wcSellKitPricingHandle);

        function wcSellKitPricingHandle() {
        $(this).siblings().removeClass('popular');
        $(this).addClass('popular');

        $(this).parents('.price-plan-wrapper').siblings().find('.rex-dynamic-price-content-area').removeClass('popular')

        // Find the radio input within the clicked dynamic price content area
        var $radioInput = $(this).find('input[type="radio"]');

        // Check if the radio input is not already checked
        if (!$radioInput.prop('checked')) {
            // Uncheck all radio inputs within rex-dynamic-pricing-area
            $('.rex-dynamic-pricing-area input[type="radio"]').prop('checked', false);

            // Check the radio input within the clicked dynamic price content area
            $radioInput.prop('checked', true);
        }

        $(this).parent().siblings( '.rex-dynamic-price-btn' ).children('a').attr( 'href', $radioInput.val() );
        }

        /**
         * Show the loader when the dynamic price button is clicked.
         *
         * This function is triggered when the dynamic price button within the
         * price sticky area is clicked. It shows the loader by displaying it
         * within the button.
         */
        $('.rex-price-sticky-area .rex-dynamic-price-btn .wpfm-btn').on('click', function(){
            $(this).children('.rex-loader').show();
        });

        //----for single price plan----
        $('.price-plan-wrapper .single-plan .wpfm-btn').on('click', function(){
            $('.price-plan-wrapper .rex-dynamic-price-btn .wpfm-btn').hide();
            $(this).parents('.price-plan-wrapper').siblings().find('.rex-loader').hide();
            $(this).parents('.single-plan').siblings().find('.rex-loader').hide();
            $(this).children('.rex-loader').show();
        });

        //----dynamic price----
        $('.price-plan-wrapper .rex-dynamic-price-btn .wpfm-btn').on('click', function(){
            $(this).parents('.price-plan-wrapper').find('.single-plan .rex-loader').hide();
            $(this).parents('.price-plan-wrapper').siblings().find('.rex-loader').hide();
            $(this).children('.rex-loader').show();
        });

        //----for single price plan----
        $('.price-plan-wrapper .single-plan .price-btn>a').on('click', function(){
            $(this).parents('.price-plan-wrapper').siblings().find('.rex-loader').hide();
            $(this).parents('.single-plan').siblings().find('.rex-loader').hide();
            $(this).children('.rex-loader').css('display', 'inline-block');
        });

        //----for wpvr price plan----
        $('.price-plan-wrapper .single-plan .wpvr-cta-btn').on('click', function(){
            $(this).parents('.price-plan-wrapper').siblings().find('.btn-icon svg').show();
            $(this).parents('.price-plan-wrapper').siblings().find('.rex-loader').hide();

            $(this).parents('.single-plan').siblings().find('.btn-icon svg').show();
            $(this).parents('.single-plan').siblings().find('.rex-loader').hide();

            $(this).find('svg').hide();
            $(this).find('.rex-loader').show();
        });

    });

    $(document).ready(function(){
        $('#apply_discount').click(function(e){
        // Prevent the default form submission behavior
        e.preventDefault();
        // Retrieve the discount code from the input field
        var discount_code = $('.rex-discount-input').val();

        // Set the discount code as the value of the target field
        $('#edd-discount').val(discount_code);

        // Retrieve the discount code from the target field (optional)
        var discount_code_val = $('#edd-discount').val();

        // Trigger a click event on another element to apply the discount
        $('.edd-apply-discount').click();


        });

        // copy referral url

        $('#rex-copy-referral-url').on('click', function(e) {
            e.preventDefault(); // Prevent default action
            const textToCopy = $('#link-texts').text();

            if (navigator.clipboard && navigator.clipboard.writeText) {

                navigator.clipboard.writeText(textToCopy).then(() => {

                    $('#link-text').text('Copied!');

                    setTimeout(() => {
                        $('#link-text').text('');
                    }, 2000);

                }).catch(err => {
                    console.error('Failed to copy: ', err);
                });
            } else {
                // Fallback method
                const tempInput = document.createElement('textarea');
                tempInput.value = textToCopy;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    document.execCommand('copy');
                    $('#link-text').text('Copied!');
                    setTimeout(() => {
                        $('#link-text').text('');
                    }, 2000);
                } catch (err) {
                    console.error('Fallback: Oops, unable to copy', err);
                }
                document.body.removeChild(tempInput);
            }
        });


        $('.rex_edd_discount_link').on('click',function(){
        $("#checkout-discount").show()
        $("#rex_edd_show_discount").hide()
        })

        $('#edd_sl_show_renewal_form').click(function(e){
            $('.renew-title').hide()
        })


        $('#edd-cancel-license-renewal').click(function(e){
            $('.renew-title').show()
        })

        // Attach click event handler to tab links
        $('.supported-marketplace .rex-tab-links a').on('click', function(e) {
            e.preventDefault(); // Prevent default link behavior

            // Get the target tab's href attribute
            var currentTab = $(this).attr('href');

            // Hide all tab contents
            $('.rex-tab-content > div').hide().fadeOut("slow");

            // Remove 'active' class from all tab links
            $('.rex-tab-links li').removeClass('active');

            // Show the clicked tab content with animation
            $(currentTab).css({"display": "grid" ,"opacity": 1}).fadeIn("slow");

            // Add 'active' class to the parent <li> of the clicked tab link
            $(this).parent().addClass('active');
        });


        // Show the first tab by default
        $('.rex-tab-content > div:first-of-type').css("display", "grid");
        $('.rex-tab-links li:first-of-type').addClass('active');


        function checkWindowWidth() {
            var windowWidth = $(window).width();
            if (windowWidth < 992) {
                if($(".rex-blog-navigation").length > 0 && $(".rex-mobile-table-of-content").length > 0)
                var getToc = $(".rex-blog-navigation").html();
                $(".rex-mobile-table-of-content").html(getToc);
            }
        }

        // Initial check when the document is ready
        checkWindowWidth();

        // Event listener for window resize
        $(window).on('resize',function() {
            // Recheck the window width on resize
            checkWindowWidth();
        });

    });

    //--------blog post category ajax filter-------
    $(document).ready(function(){

        $('.rextheme-category-filter li').on('click', function() {
            var catVal = $(this).attr("cat-value");
            var author_id = $(this).attr("author-id");
            $('.rextheme-loadmore-btn').attr('data-category', catVal);
            var catText = $(this).text();

            $('.rex-blog-recent-trending-post-area').hide();
            $(this).parents('body.blog').find('#rex-blog-section-title').html(
                '' +
                '<span class="highlight">' +
                catText + // This assumes catText is a variable holding the desired text
                '</span> Articles'
                );

                $('.rex-blog-section-title').addClass('hide-padding');
                $('.rex-blog-recent-sticky-area').addClass('add-padding');



            $(this).parents('body.archive').find('#rex-blog-section-title .highlight').text(catText);

            // Smoothly fade out the content before making the AJAX request
            $('.rex-blog-content, #blog-pagination-container').fadeTo(400, 0.3);
            $.ajax({
                type: 'POST',
                url: rextheme_ajax.url,
                dataType: 'JSON',
                data: {
                    action: 'rextheme_blog_post_filter',
                    category: catVal,

                    authorID: author_id
                },
                success: function(res) {
                    // page = 2; // Initial page number
                    // canLoadMore = true;
                    $('.rex-blog-content').html(res.html);
                    var paginationContainer = $('#blog-pagination-container');
                    paginationContainer.html(res.pagination);

                        // Fade in smoothly after content is replaced
                        $('.rex-blog-content, #blog-pagination-container').fadeTo(400, 1);


                    if( 'no' === res.isLoadMore ){
                        $('.load-more-container').hide();
                    }else{
                        $('.load-more-container').css('display','flex');
                    }
                }
            })

            $('.rextheme-category-filter li.active').removeClass('active');
            $(this).addClass('active');

        });
    });

    //-------- Blog Nav Scroll -----------
    //Scroll Right
    $(document).on('click', '.rextheme-post-category .cat-next-btn button', function(){
        const $categoryFilter = $('.rextheme-post-category .rextheme-category-filter');
        let leftScrolled = $categoryFilter.scrollLeft();
        let scrollAbleWidth = $categoryFilter.prop('scrollWidth') - leftScrolled - $categoryFilter.width() - 200

        //Hiding the button and before effect
        if(0 >= scrollAbleWidth){
            $(this).css('display', 'none');
            $('.rextheme-post-category.rextheme-scroll-right-shadow-active').removeClass('rextheme-scroll-right-shadow-active')
        }

        //Scroll
        let scrollValue = 200;
        $categoryFilter.scrollLeft(scrollValue + leftScrolled);

        //Enable Previous button and after Effect
        $('.rextheme-post-category .cat-pre-btn button').css('display', 'block')
        $('.rextheme-post-category').addClass('rextheme-scroll-left-shadow-active')

    })

    //Scroll Left
    $(document).on('click', '.rextheme-post-category .cat-pre-btn button', function(){
        const $categoryFilter = $('.rextheme-post-category .rextheme-category-filter');
        let leftScrolled = $categoryFilter.scrollLeft();

        //Hiding the button and before effect
        if(200 >= leftScrolled){
            $(this).css('display', 'none');
            $('.rextheme-post-category.rextheme-scroll-left-shadow-active').removeClass('rextheme-scroll-left-shadow-active')
        }

        //Scroll
        let scrollValue = 200;
        $categoryFilter.scrollLeft(leftScrolled - scrollValue);

        //Enable Next button and after Effect
        $('.rextheme-post-category .cat-next-btn button').css('display', 'block')
        $('.rextheme-post-category').addClass('rextheme-scroll-right-shadow-active')

    })

    $('.rextheme-post-category .rextheme-category-filter').on('scroll',function(){
        let leftScrolled = $(this).scrollLeft()
        let scrollAbleWidth = $(this).prop('scrollWidth') - leftScrolled - $(this).width()
        //Adding the previous button and after effect
        if(0 < leftScrolled){
            $('.rextheme-post-category .cat-pre-btn button').css('display', 'block');
            $('.rextheme-post-category').addClass('rextheme-scroll-left-shadow-active')
        }

        //Adding the next button and before effect
        if(0 < scrollAbleWidth){
            $('.rextheme-post-category .cat-next-btn button').css('display', 'block');
            $('.rextheme-post-category').addClass('rextheme-scroll-right-shadow-active')
        }

        //Hiding the previous button and after effect
        if(0 >= leftScrolled){

            $('.rextheme-post-category .cat-pre-btn button').css('display', 'none');
            $('.rextheme-post-category.rextheme-scroll-left-shadow-active').removeClass('rextheme-scroll-left-shadow-active')
        }

        //Hiding the next button and before effect
        if(0 >= scrollAbleWidth){
            $('.rextheme-post-category .cat-next-btn button').css('display', 'none');
            $('.rextheme-post-category.rextheme-scroll-right-shadow-active').removeClass('rextheme-scroll-right-shadow-active')
        }
    });

    //Scroll with mouse Drag
    $(document).ready(function() {
        var container = $('.rextheme-post-category .rextheme-category-filter');
        var startX, scrollLeft, isDown, scrollTop;

        container.on('mousedown', function(e) {
            mouseIsDown(e);
        });

        container.on('mouseup', function(e) {
            mouseUp(e);
        });

        container.on('mouseleave', function(e) {
            mouseLeave(e);
        });

        container.on('mousemove', function(e) {
            mouseMove(e);
        });

        function mouseIsDown(e) {
            isDown = true;
            startX = e.pageX - container.offset().left;
            scrollLeft = container.scrollLeft();
            scrollTop = container.scrollTop();
        }

        function mouseUp(e) {
            isDown = false;
        }

        function mouseLeave(e) {
            isDown = false;
        }

        function mouseMove(e) {
            if (isDown) {
            e.preventDefault();

            // Move Horizontally
            var x = e.pageX - container.offset().left;
            var walkX = x - startX;
            container.scrollLeft(scrollLeft - walkX);
            }
        }

    });

    $(document).ready(function() {
        $('#rex-search-input').on('click', function() {
            $('.rex-search-input-group').removeClass('rex-input-hidden');
            $('.form-control').css('width', '100%');
            $('.rex-blog-form-control').focus();
        });

        $('.rex-blog-form-control').on('change', function() {
            if($(this).val().length > 0) {
                $("#rex-search-input").attr('type', 'submit');
            }
        });

        // Explicitly handle the submit click event
        $('#rex-search-input').on('click', function(event) {
            if ($(this).attr('type') === 'submit') {
                event.preventDefault();
            }
        });

        $('.rex-notification-counter__btn,.bf-hero__content .rextheme-cta-btn,.cm-hero-area .rextheme-cta-btn').on('click', function(event) {
            const targetUrl = $(this).attr('href');
            const targetSection = '#pricing';

            if (targetUrl.includes(targetSection)) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: $(targetSection).offset().top
                }, 800); // Adjust scroll speed as needed
            }
        });

    });

    function updateCountdown(timeLeft) {
        // Calculate the number of days, hours, minutes, and seconds remaining
        const days = Math.floor(timeLeft / (60 * 60 * 24)).toString().padStart(2, '0');
        const hours = Math.floor((timeLeft % (60 * 60 * 24)) / (60 * 60)).toString().padStart(2, '0');
        const minutes = Math.floor((timeLeft % (60 * 60)) / (60)).toString().padStart(2, '0');
        const seconds = Math.floor(timeLeft % 60).toString().padStart(2, '0');

        // Update the countdown values in the HTML
        $('#rex-halloween-days').text(days);
        $('#rex-halloween-hours').text(hours);
        $('#rex-halloween-mins').text(minutes);
        $('#rex-halloween-secs').text(seconds);

        // If timeLeft is zero or less, stop the countdown and hide the banner
        if (timeLeft <= 0) {
            clearInterval(countdownInterval); // Stop the countdown interval
            $('.rex-notification-counter').hide(); // Hide the countdown banner
        }
    }

    $(document).ready(function() {
      let timeLeft = window?.rextheme_ajax?.special_deal_time_remaining
        // Set an interval to update the countdown every second
        window.countdownInterval = setInterval(()=> {
          updateCountdown(timeLeft);
          timeLeft--;
        }, 1000);
    });

    function createSnowflakes() {
        const scene = document.querySelector('.cm-hero-area');

            if(scene) {
                for (let i = 0; i < 100; i++) {
                    const snowflake = document.createElement('div');
                    snowflake.classList.add('snowflake');

                    // Randomize snowflake properties
                    snowflake.style.left = `${Math.random() * 100}vw`;
                    snowflake.style.animationDuration = `${Math.random() * 10 + 5}s`;
                    snowflake.style.width = `${Math.random() * 5 + 2}px`;
                    snowflake.style.height = snowflake.style.width;

                    scene.appendChild(snowflake);
                }
            }

    }

    // Call when page loads
    window.addEventListener('load', createSnowflakes);

    jQuery(document).ready(function ($) {

        $('#load-more').on('click', function () {
            let button = $(this);
            let offset = parseInt(button.attr('data-offset'));
            let loader = $('#loader');

            // Show the loader
            loader.show();

            $.ajax({
                url: window?.rextheme_ajax.url,
                type: 'POST',
                data: {
                    action: 'rex_load_more_images',
                    offset: offset,
                    security: window?.rextheme_ajax.nonce,
                    page_id: parseInt(button.attr('data-page-id'))
                },
                success: function (response) {
                    if (response.success) {
                        $('#image-gallery').append(response.data.html); // Append the new images
                        let responseOffset = parseInt(response.data.offset),
                            responseTotal = parseInt(response.data.total);
                        button.attr('data-offset', offset + 3).text('Load More').prop('disabled', false);
                        if(responseOffset >= responseTotal) {
                            $("#load-more").hide();// Disable the button if no more images
                        }
                    } else {
                        button.text('No More Images').prop('disabled', true); // Disable the button if no more images
                    }
                },

                error: function() {
                  console.log('Error');
                },
                complete: function () {
                    loader.hide();
                }
            });
        });


        // var hash = $(location).attr("href");

        // var urlParts = hash.split('/');
        // var docsCategory = urlParts[3];
        // if(docsCategory === 'docs-category'){
        //     var newUrl = $(location).attr("protocol") + "//" + $(location).attr("hostname") + '/docs/' + urlParts[4];
        //     window.location.replace(newUrl);
        // }


    });

    document.addEventListener('DOMContentLoaded', () => {
        // Select the heading inside the 'post-type-archive-docs' container
        const heading = document.querySelector('.post-type-archive-docs .heading');

        // Check if the heading exists
        if (heading) {
            const text = heading.innerHTML;

            // Replace 'Help' with a span containing the word styled in a specific color
            heading.innerHTML = text.replace(/Help/i, '<span style="color:#201CFE;">Help</span>');
        }


      $(document).on("click", "#premium-features-link", function (event) {
            event.preventDefault();
            $("#rextheme_premium_feature_popup").addClass("active");
            $('body').addClass('scroll-off');
        });

        $(document).on("click", "#rextheme_premium_feature_close", function () {
            $("#rextheme_premium_feature_popup").removeClass("active");
            $('body').removeClass('scroll-off');
        });



    });


}(jQuery));
